import * as moment from "moment"

export const MOBILE_WIDTH = 768

export const formatDate = (date?: string) => {
  return moment(date).format("MMM Do, YYYY")
}

export const UNITS_PER_BOX = 25

export const howOften = ["Monthly", "Quarterly", "Annually"]

export const productsActionQty = [
  { action: "/inquiry-c", quantity: "75 - 150 units" },
  { action: "/inquiry-b", quantity: "151 - 500 units" },
  { action: "/inquiry-a", quantity: "501 - 1000 units" },
  { action: "/inquiry-a", quantity: "1,000+ units" },
]

export const covidProductQuantities = [
  "< 500",
  "500-1,000",
  "1,000-5,000",
  "5,000-25,000",
  "25,000+",
]

export const labTypes = [
  "Yes, we are a moderate complexity CLIA laboratory",
  "Yes, we are a high complexity CLIA laboratory",
  "No, however we supply moderate/high complexity CLIA laboratories.",
  "No, but I would like to stay updated on the product",
]
